import clsx from 'clsx'
import isEmpty from 'lodash/isEmpty'
import React, { FC, FormEvent, useRef, useState } from 'react'

import SvgCheck from '@Assets/SVG/Check'
import SvgClose from '@Assets/SVG/Close'
import { SVGIcon } from '@Components/Icons'
import { useTranslation } from '@Globals/Translations'

import styles from './SideCartCouponCode.module.scss'

export interface SideCartCouponCodeProps {
  applyCouponCode: (code: string) => Promise<{ errorMessage?: string, success: boolean }>
  v2?: boolean
}

export const SideCartCouponCode: FC<SideCartCouponCodeProps> = ({ applyCouponCode, v2 }) => {
  const { t } = useTranslation()
  const inputRef = useRef<HTMLInputElement | null>(null)
  const [code, setCode] = useState('')
  const [error, setError] = useState<string | undefined>()
  const [success, setSuccess] = useState(false)

  const handleSubmit = async (event?: FormEvent) => {
    event?.preventDefault()

    if (isEmpty(code)) {
      setError(t('validation:INPUT_FIELD_IS_REQUIRED'))
      setSuccess(false)
    } else {
      const response = await applyCouponCode(code)
      setSuccess(response.success)
      setError(response.errorMessage)
    }
  }

  const reset = () => {
    setCode('')
    setError('')
    setSuccess(false)
  }

  const handleRemove = () => {
    reset()
    inputRef.current?.focus()
  }

  return (
    <div className={clsx(styles.sideCartCouponCode, v2 && styles.sideCartCouponCodeV2)}>
      <p className={styles.text}>{t('cart:DISCOUNT_CODE_OR_GIFT_CARD')}</p>

      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.fieldWrapper}>
          <div className={styles.inputWrapper}>
            <input
              className={styles.input}
              onChange={event => setCode(() => event.target.value)}
              placeholder={t('cart:DISCOUNT_CODE_OR_GIFT_CARD').replace(':', '')}
              ref={inputRef}
              value={code}
            />

            {success && (
              <SVGIcon className={styles.success} icon={SvgCheck} />
            )}

            {code && (
              <button aria-label="close" className={styles.remove} onClick={handleRemove} type="button">
                <SVGIcon className={styles.removeIcon} icon={SvgClose} />
              </button>
            )}
          </div>
          <button className={styles.submit} type="submit">
            {t('common:APPLY')}
          </button>
        </div>

        {!!error && <span className={styles.error}>{error}</span>}
      </form>
    </div>
  )
}

